//
// Module for the Benefit Claims Edit view
//
rs.module("participant/benefit/claims/edit",

    [
        "common/select-helper",
        "common/visibility",
        "controls/data/grid",
        "controls/components/event-banner"
    ],

    function (selectHelper, visibility, gridModule, eventBanner) {

        function initialize(jsSelectors, backendUrls, constants, deathRecipientsGridLrsApi) {

            // initialize js selectors
            var claimDetailForm = $.js(jsSelectors.claimDetailForm);

            var separationType = claimDetailForm.js(jsSelectors.separationType, { required: false });
            var separationSubType = claimDetailForm.js(jsSelectors.separationSubType, { required: false });
            var separationDate = claimDetailForm.js(jsSelectors.separationDate, { required: false });
            var separationDateHiddenInput = claimDetailForm.js(jsSelectors.separationDateHiddenInput, { required: false });
            var separationDateError = claimDetailForm.js(jsSelectors.separationDateError, { required: false });
            var basisPlan = claimDetailForm.js(jsSelectors.basisPlan, { required: false });
            var basisPlanHiddenInput = claimDetailForm.js(jsSelectors.basisPlanHiddenInput, { required: false });
            var basisPlanError = claimDetailForm.js(jsSelectors.basisPlanError, { required: false });
            var splitPlan = claimDetailForm.js(jsSelectors.splitPlan, { required: false });
            var benefitEffectiveDate = claimDetailForm.js(jsSelectors.benefitEffectiveDate, { required: false });
            var benefitEffectiveDateHiddenInput = claimDetailForm.js(jsSelectors.benefitEffectiveDateHiddenInput, { required: false });
            var benefitTerminationDate = claimDetailForm.js(jsSelectors.benefitTerminationDate, { required: false });
            var benefitTerminationDateHiddenInput = claimDetailForm.js(jsSelectors.benefitTerminationDateHiddenInput, { required: false });
            var backDropMonths = claimDetailForm.js(jsSelectors.backDropMonths, { required: false });
            var backDropMonthsError = claimDetailForm.js(jsSelectors.backDropMonthsError, { required: false });
            var backDropDate = claimDetailForm.js(jsSelectors.backDropDate, { required: false });
            var backDropDateHiddenInput = claimDetailForm.js(jsSelectors.backDropDateHiddenInput, { required: false });
            var refundType = claimDetailForm.js(jsSelectors.refundType, { required: false });
            var refundTypeError = claimDetailForm.js(jsSelectors.refundTypeError, { required: false });
            var refundReason = claimDetailForm.js(jsSelectors.refundReason, { required: false });
            var refundReasonError = claimDetailForm.js(jsSelectors.refundReasonError, { required: false });
            var disabilityApplication = claimDetailForm.js(jsSelectors.disabilityApplication, { required: false });
            var disabilityApplicationError = claimDetailForm.js(jsSelectors.disabilityApplicationError, { required: false });
            var dropEntryDate = claimDetailForm.js(jsSelectors.dropEntryDate, { required: false });
            var dropPlan = claimDetailForm.js(jsSelectors.dropPlan, { required: false });
            var isEditingDeathClaimDetails = claimDetailForm.js(jsSelectors.isEditingDeathClaimDetails, { required: false });
            var deathSourceBenefit = claimDetailForm.js(jsSelectors.deathSourceBenefit, { required: false });
            var deathSourceBenefitHiddenInput = claimDetailForm.js(jsSelectors.deathSourceBenefitHiddenInput, { required: false });
            var deathBenefit = claimDetailForm.js(jsSelectors.deathBenefit, { required: false });
            var deathBenefitHiddenInput = claimDetailForm.js(jsSelectors.deathBenefitHiddenInput, { required: false });
            var changeDetailsButton = claimDetailForm.js(jsSelectors.changeDetailsButton, { required: false });
            var cancelChangesButton = claimDetailForm.js(jsSelectors.cancelChangesButton, { required: false });
            var recipientsError = claimDetailForm.js(jsSelectors.recipientsError, { required: false });
            var cancelButton = claimDetailForm.js(jsSelectors.cancelButton, { required: false });

            // initialize select helpers
            var basisPlanSelectHelper = selectHelper.getHelper(basisPlan);
            var backDropMonthsSelectHelper = selectHelper.getHelper(backDropMonths);
            var refundTypeSelectHelper = selectHelper.getHelper(refundType);
            var refundReasonSelectHelper = selectHelper.getHelper(refundReason);
            var disabilityApplicationSelectHelper = selectHelper.getHelper(disabilityApplication);
            var dropPlanSelectHelper = selectHelper.getHelper(dropPlan);
            var deathSourceBenefitSelectHelper = selectHelper.getHelper(deathSourceBenefit);
            var deathBenefitSelectHelper = selectHelper.getHelper(deathBenefit);

            // recalculate BackDROP date when either field used in the calculation changes
            benefitEffectiveDate.change(reloadBackDropDate);
            backDropMonths.change(reloadBackDropDate);

            // separation type change handler - clear/disable corresponding fields
            separationType.change(function () {

                separationDateError.text("");
                basisPlanError.text("");
                refundTypeError.text("");
                refundReasonError.text("");
                disabilityApplicationError.text("");

                var selectedSeparationType = separationType.val();

                // configure retirement-only fields
                if (selectedSeparationType == constants.retirement) {
                    backDropMonthsSelectHelper.setDisabled(!constants.backDropEnabled); // only enable back DROP if allowed by fund
                }
                else {
                    backDropMonthsSelectHelper.setValue(null).setDisabled(true);
                    backDropDate.val("");
                    backDropDateHiddenInput.val("");
                }

                // configure refund-only fields
                if (selectedSeparationType == constants.refund) {
                    basisPlanSelectHelper.setDisabled(false);
                    refundTypeSelectHelper.setDisabled(false);
                }
                else {
                    separationDate.prop("disabled", constants.isSeparationDateDetermined); // only enable separation date if not pre-determined
                    basisPlanSelectHelper.setDisabled(false);
                    refundTypeSelectHelper.setValue(null).setDisabled(true);
                    refundReasonSelectHelper.setValue(null).setDisabled(true);
                }

                // configure disability-only fields
                if (selectedSeparationType == constants.disabilityRetirement) {
                    disabilityApplicationSelectHelper.setDisabled(false);
                }
                else {
                    disabilityApplicationSelectHelper.setValue(null).setDisabled(true);
                }

                // configure split plan (used across multiple separation types)
                if (splitPlan.length > 0) {

                    if (selectedSeparationType == constants.retirement || selectedSeparationType == constants.disabilityRetirement) {
                        splitPlan.prop("disabled", false);
                    }
                    else {
                        splitPlan.prop("disabled", true).setChecked(false);
                    }
                }
            });

            // basis plan change handler - reload death source/available benefits (if applicable)
            basisPlan.change(function () {
                if (deathSourceBenefit.length > 0 && !constants.isActiveOrDeferredDeath) {

                    // reload death source benefits
                    deathSourceBenefitSelectHelper.loadOptionsFrom(
                        backendUrls.getDeathSourceBenefits,
                        {
                            basisPlanKey: basisPlan.val()
                        });
                }

                if (deathBenefit.length > 0) {

                    // reload death benefits
                    deathBenefitSelectHelper.loadOptionsFrom(
                        backendUrls.getDeathBenefits,
                        {
                            separationType: separationType.val(),
                            separationSubType: separationSubType.val(),
                            basisPlanKey: basisPlan.val()
                        });
                }
            });

            // refund type change handler - clear/disable corresponding fields
            refundType.change(function () {

                separationDateError.text("");
                refundReasonError.text("");

                if (refundType.val() == constants.partialBalanceRefund) {

                    if (!constants.isSeparationDateDetermined) {
                        separationDate.prop("disabled", true).val("");
                    }

                    refundReasonSelectHelper.replaceOptions(constants.partialBalanceRefundReasons, { withBlank: true }).setDisabled(false);
                }
                else {
                    separationDate.prop("disabled", constants.isSeparationDateDetermined);
                    refundReasonSelectHelper.setValue(null).setDisabled(true);
                }
            });

            // DROP entry date change handler
            dropEntryDate.change(_.debounce(function () {
                dropEntryDateChanged();
            }, 500));

            // reload DROP plans and recalculate separation date
            function dropEntryDateChanged() {

                if (dropEntryDate.val() && dropEntryDate.valid()) {

                    // get the new DROP entry date
                    var dropEntryDt = dropEntryDate.val();

                    // copy it to the benefit effective date
                    benefitEffectiveDate.val(dropEntryDt);
                    benefitEffectiveDateHiddenInput.val(dropEntryDt);

                    // reload DROP plans
                    dropPlanSelectHelper.loadOptionsFrom(
                        backendUrls.getDropPlans,
                        {
                            dropEntryDate: dropEntryDt,
                            selectedDropPlanKey: dropPlan.val()
                        },
                        { withBlank: true });

                    // reload separation date
                    $.ajax({
                        url: backendUrls.getDropSeparationDate,
                        data: {
                            dropEntryDate: dropEntryDt
                        },
                        success: function (data) {
                            separationDate.val(data.separationDate);
                            separationDateHiddenInput.val(data.separationDate);
                        }
                    });
                }
                else {
                    dropPlanSelectHelper.clearOptions();
                    separationDate.val("");
                    separationDateHiddenInput.val("");
                }
            }

            // change details click handler - clear/disable corresponding fields and reload recipients grid
            changeDetailsButton.click(function () {

                if (isEditingDeathClaimDetails.normalizedBoolVal()) {

                    isEditingDeathClaimDetails.val(false);
                    changeDetailsButton.text(constants.changeDetails);
                    visibility.hide(cancelChangesButton);
                    visibility.show(cancelButton);

                    // copy detail fields to hidden inputs
                    basisPlanHiddenInput.val(basisPlan.val());
                    benefitEffectiveDateHiddenInput.val(benefitEffectiveDate.val());
                    benefitTerminationDateHiddenInput.val(benefitTerminationDate.val());
                    deathSourceBenefitHiddenInput.val(deathSourceBenefit.val());
                    deathBenefitHiddenInput.val(deathBenefit.val());

                    // disable detail fields
                    basisPlanSelectHelper.setDisabled(true);
                    benefitEffectiveDate.prop("disabled", true);
                    benefitTerminationDate.prop("disabled", true);
                    deathSourceBenefitSelectHelper.setDisabled(true);
                    deathBenefitSelectHelper.setDisabled(true);

                    // reload recipients
                    gridModule.update(
                        backendUrls.loadRecipientsGrid,
                        {
                            claimPaymentSourceKey: deathSourceBenefit.val(),
                            deathType: deathBenefit.val()
                        },
                        deathRecipientsGridLrsApi.agGridApi,
                    function done() { }
                    )
                }
                else {

                    recipientsError.text("");
                    eventBanner.removeErrorMessages();

                    isEditingDeathClaimDetails.val(true);
                    changeDetailsButton.text(constants.loadRecipients);
                    visibility.show(cancelChangesButton);
                    visibility.hide(cancelButton);

                    // enable detail fields
                    basisPlanSelectHelper.setDisabled(constants.isActiveDrop);                      // only enable basis plan if not Active DROP 
                    benefitEffectiveDate.prop("disabled", false);
                    benefitTerminationDate.prop("disabled", false);
                    deathSourceBenefitSelectHelper.setDisabled(constants.isActiveOrDeferredDeath);  // only enable death source benefit if not Active or Deferred death 
                    deathBenefitSelectHelper.setDisabled(false);

                    // clear recipients
                    deathRecipientsGridLrsApi.clearGridRows();
                }
            });

            // recalculate back drop date based on inputs
            function reloadBackDropDate() {
                if (benefitEffectiveDate.val() && benefitEffectiveDate.valid() && backDropMonths.val() && !backDropMonthsError.text()) {
                    $.ajax({
                        url: backendUrls.getBackDropDate,
                        data: {
                            benefitEffectiveDate: benefitEffectiveDate.val(),
                            backDropMonths: backDropMonths.val()
                        },
                        success: function (data) {
                            backDropDate.val(data.backDropDate);
                            backDropDateHiddenInput.val(data.backDropDate);
                        }
                    });
                }
                else {
                    backDropDate.val("");
                    backDropDateHiddenInput.val("");
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);